import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { AccountRefillService } from '@ztarmobile/zwp-service-backend';
import { ActivatedRoute, Router } from '@angular/router';
import { SHOP_ROUTE_URLS } from '../../../app.routes.names';
import { MetaService } from '../../../../services/meta-service.service';
import { ModalHelper } from 'src/services/modal-helper.service';
import { AppState } from '@app/app.service';
import { Subscription } from 'rxjs';
import { CAPTCHA_BOT_ERROR_CODE } from '@app/app.config';

@Component({
  selector: 'app-quick-voucher',
  templateUrl: './quick-voucher.component.html',
  styleUrls: ['../quick-top-up.component.scss']
})

export class QuickVoucherComponent implements OnInit, OnDestroy {
  public voucherForm: FormGroup;
  public recaptchaResponse: any;
  public phoneNumber: any;
  public recaptchaResolvedSubscription: Subscription;
  
  constructor(
    public router: Router,
    public modalHelper: ModalHelper,
    private formBuilder: FormBuilder,
    private accountRefillService: AccountRefillService,
    private route: ActivatedRoute,
    private metaService: MetaService,
    private appState: AppState) {

    this.route.params.subscribe(params => {
      this.phoneNumber = params.mdn;
      this.phoneNumber = this.phoneNumber?.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
    });
    this.voucherForm = formBuilder.group({
      voucherNumber: ['', Validators.compose([Validators.required, Validators.maxLength(16), Validators.minLength(12)])],
      confirmVoucherNumber: ['', Validators.compose([Validators.required, Validators.maxLength(16), Validators.minLength(12)])],
    }, { validator: this.matchingVoucherNumber('voucherNumber', 'confirmVoucherNumber') });
  }

  ngOnInit(): void {
    this.metaService.createCanonicalUrl();
  }

  ngOnDestroy(): void {
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }

  public submitQuickTopUp(): void {
    this.voucherForm.markAllAsTouched();
    const action = 'freeup_refill_using_mobile_number'
    if (!!this.voucherForm.valid) {
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({ action });
      this.recaptchaResolvedSubscription = this.appState.resolvedCaptcha.subscribe(response => {
        this.recaptchaResponse = response;
        if (!!this.recaptchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callRefillUsingMobileNumber(this.recaptchaResponse, true, action);
        }
        });
    }
  }

  public callRefillUsingMobileNumber(captchaRes, invisibleCaptchaRes, action?): void {
    const mdn = this.phoneNumber?.replace(/[^a-zA-Z0-9]/g, '');
    const pin = this.voucherForm.get('voucherNumber').value;
    if (!!pin && !!mdn) {
      this.accountRefillService.refillUsingMobileNumber(mdn, pin, captchaRes, !!action ? action : null, invisibleCaptchaRes).then((account) => {
        if (!!account) {
          this.appState.loading = false;
          const params = [];
          params[SHOP_ROUTE_URLS.PARAMS.MDN] = mdn;
          this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.SUCCESS_QUICK_TOP_UP}`, params]);
        } else {
          this.appState.loading = false;
          this.modalHelper.showConfirmMessageModal('PIN Used',
            'This pin has already been used, please check the PIN, or contact Support at 888-316-0686 form more information',
            'TRY AGAIN', 'CLOSE', 'pin-used').afterClosed().subscribe((results) => {
              if (!!results) {
                this.voucherForm.reset();
              }
            });

        }
      }, (error) => {
        this.appState.loading = false;
        if (error?.code === CAPTCHA_BOT_ERROR_CODE) {
          this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result) => {
            if (!!result) {
              this.appState.loading = true;
              this.callRefillUsingMobileNumber(result, false);
            }
          });
        } else {
          this.modalHelper.showInformationMessageModal('PIN Top-up Failed',
            'Something went wrong',
            'Close', null, false, 'failed-pin', `${error?.message || error}`);
        }
      });
    }
  }
  public backPreviousPage(): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.MDN_QUICK_TOP_UP}`]);
  }

  public onPaste(event: any): void {
    event.preventDefault();
  }

  private matchingVoucherNumber(pin: string, confirmPin: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const voucherNumber = group.get(pin);
      const confirmVoucherNumber = group.get(confirmPin);

      if (voucherNumber && confirmVoucherNumber && !!voucherNumber?.value && !!confirmVoucherNumber?.value && voucherNumber.value !== confirmVoucherNumber.value) {
        confirmVoucherNumber.setErrors({ mismatchedVoucherNumber: true });
        return { mismatchedVoucherNumber: true };
      }
    };
  }
}
